import { createFileRoute } from "@tanstack/react-router";
import { NeucleosAccessPage } from "../components/settings/NeucleosAccessPage";

export const Route = createFileRoute("/settings/neucleos-access")({
  component: NeucleosAccessPage,
});
